import {
  updatePegionPark,
  fetchParkSettingsMinMaxSum,
  createParkSettings,
  toggleAutoGenerationWaybills,
} from '@/requests/regionPark'
import Api from '@/repository/index'
import { deleteParkSettings } from '@/requests/settings'
import {
  showErrorMessage,
  showDefaultErrorMessage,
  showSuccessMessage,
  errorResponseMessage,
} from '@/utils/createMessage'
import { Message } from 'element-ui'

const TOGGLE_LOADING = 'TOGGLE_LOADING'
const TOGGLE_LOADING_MIN_MAX = 'TOGGLE_LOADING_MIN_MAX'
const SET_REGION_PARK = 'SET_REGION_PARK'
const ADD_REGION_PARK = 'ADD_REGION_PARK'
const REMOVE_REGION_PARK = 'REMOVE_REGION_PARK'
const UPDATE_REGION_PARK = 'UPDATE_REGION_PARK'
const REMOVE_SETTINGS_ID_DATA_PARK = 'REMOVE_SETTINGS_ID_DATA_PARK'
const ADD_SETTINGS_ID_DATA_PARK = 'ADD_SETTINGS_ID_DATA_PARK'

const state = {
  isLoading: true,
  isLoadingMinMax: true,
  regionPark: [],
}

const mutations = {
  [TOGGLE_LOADING](state, bool) {
    state.isLoading = bool
  },
  [TOGGLE_LOADING_MIN_MAX](state, bool) {
    state.isLoadingMinMax = bool
  },

  [SET_REGION_PARK](state, data) {
    state.regionPark = data
  },

  [ADD_REGION_PARK](state, item) {
    state.regionPark.push(item)
  },

  [UPDATE_REGION_PARK](state, item) {
    const index = state.regionPark.findIndex((e) => e.id === item.id)
    state.regionPark.splice(index, 1, item)
  },
  [REMOVE_SETTINGS_ID_DATA_PARK]: (state, settingsId) => {
    const index = state.regionPark.findIndex((e) => e.settings_id === settingsId)
    if (index === -1) return
    state.regionPark[index] = {
      ...state.regionPark[index],
      settings_id: null,
    }
  },
  [ADD_SETTINGS_ID_DATA_PARK]: (state, settingsId) => {
    const index = state.regionPark.findIndex((e) => e.settings_id === settingsId)
    if (index === -1) return
    state.regionPark[index] = {
      ...state.regionPark[index],
      settings_id: settingsId,
    }
  },
  [REMOVE_REGION_PARK](state, id) {
    const index = state.regionPark.findIndex((e) => e.id === id)
    state.regionPark.splice(index, 1)
  },
}
const actions = {
  async fetchRegionPark({ dispatch, commit, getters, rootGetters }, parkId) {
    try {
      commit(TOGGLE_LOADING, true)
      parkId = parkId || rootGetters['settings/getDefaultParkPk']
      console.log(rootGetters['settings/getDefaultParkPk'])
      const response = await Api.schedule.regionPark.getRegionParks(parkId)

      commit(SET_REGION_PARK, response)
    } catch (err) {
      showErrorMessage('Не удалось загрузить региональные парки')
      return Promise.reject(err)
    } finally {
      commit(TOGGLE_LOADING, false)
    }
  },
  async regionParkUseCommonSettings({ commit, dispatch }, data) {
    try {
      const response = await Api.parkManager.settings.regionParkUseCommonSettings(data)
      dispatch('fetchRegionPark')
      return response
    } catch (err) {
      showErrorMessage('Не удалось')
      return Promise.reject(err)
    }
  },
  async regionParkUseOwnSettings({ commit, dispatch }, data) {
    try {
      const response = await Api.parkManager.settings.regionParkUseOwnSettings(data)
      dispatch('fetchRegionPark')
      return response
    } catch (err) {
      showErrorMessage('Не удалось')
      return Promise.reject(err)
    }
  },
  async createParkSettings({ commit }, data) {
    return new Promise((resolve, reject) => {
      createParkSettings(data)
        .then((res) => {
          Message({
            message: 'Настройки были созданы',
            type: 'success',
            duration: 5 * 1000,
          })
          commit(ADD_SETTINGS_ID_DATA_PARK, {
            settings_id: data?.id,
            park_id: data?.park_id,
          })
          resolve(res)
        })
        .catch((error) => {
          Message({
            message: 'Ошибка',
            type: 'error',
            duration: 5 * 1000,
          })
          reject(error)
        })
    })
  },

  async toggleAutoGenerationWaybills({ commit }, req) {
    try {
      commit(TOGGLE_LOADING, true)
      return await toggleAutoGenerationWaybills(req)
    } finally {
      commit(TOGGLE_LOADING, false)
    }
  },

  async fetchParkSettingsMinMaxSum({ dispatch, commit, getters, rootGetters }, parkId) {
    try {
      commit(TOGGLE_LOADING_MIN_MAX, true)
      const response = await fetchParkSettingsMinMaxSum(parkId)
      commit(TOGGLE_LOADING_MIN_MAX, false)
      return response
    } catch (err) {
      showErrorMessage('Не удалось загрузить максимальные значения удержаний в парках')
      return Promise.reject(err)
    } finally {
      commit(TOGGLE_LOADING_MIN_MAX, false)
    }
  },
  async driverUnbind({ commit }, data) {
    try {
      const response = await Api.schedule.regionPark.driverUnbind(data)
      return response
    } catch (err) {
      showErrorMessage('Не удалось временно освободить водителя')
      return Promise.reject(err)
    }
  },
  async driverBind({ commit }, data) {
    try {
      const response = await Api.schedule.regionPark.driverBind(data)
      return response
    } catch (err) {
      showErrorMessage('Не удалось вернуть водителя в парк')
      return Promise.reject(err)
    }
  },
  async createPegionPark({ commit }, data) {
    try {
      const response = await Api.schedule.regionPark.createRegionPark(data)
      commit(ADD_REGION_PARK, response)
      showSuccessMessage('Региональный парк успешно создан')
      return response
    } catch (err) {
      showErrorMessage('Не удалось создать региональный парк')
      return Promise.reject(err)
    }
  },
  async deleteParkSettings({ commit, state }, settingsId) {
    try {
      console.log(settingsId)
      return await deleteParkSettings(settingsId)
        .then((data) => {
          console.log(data)
          commit('REMOVE_SETTINGS_ID_DATA_PARK', settingsId)
          showSuccessMessage('Региональный парк успешно удален')
          return data
        })
        .catch((error) => {
          showDefaultErrorMessage()
          return error
        })
      // commit('SET_CHANGES', StatisticShanges)
    } catch (err) {
      showDefaultErrorMessage()
      return Promise.reject(err)
    }
  },
  async updatePegionPark({ commit, dispatch }, data) {
    try {
      commit(TOGGLE_LOADING, true)
      const response = await Api.schedule.regionPark.updateRegionPark(data)
      commit(UPDATE_REGION_PARK, response)
      showSuccessMessage('Региональные парки успешно обновленны')
      await dispatch('fetchRegionPark')
    } catch (err) {
      // showErrorMessage('Не удалось обновить региональные парки')
      await errorResponseMessage(err.response.data)
      return Promise.reject(err)
    } finally {
      commit(TOGGLE_LOADING, false)
    }
  },
  async updateSettingsIdPegionPark({ commit, state }, { id, settings_id: settingsId }) {
    try {
      commit(TOGGLE_LOADING, true)
      const getData = state.regionPark.filter((x) => x.id === id)[0]
      const response = await updatePegionPark({
        ...getData,
        settings_id: settingsId,
      })
      commit(UPDATE_REGION_PARK, response)
    } catch (err) {
      showErrorMessage('Не удалось обновить региональные парки')
      return Promise.reject(err)
    } finally {
      commit(TOGGLE_LOADING, false)
    }
  },
  async deletePegionPark({ commit, dispatch }, id) {
    try {
      commit(TOGGLE_LOADING, true)
      await Api.schedule.regionPark.deleteRegionParkById(id)
      await dispatch('fetchRegionPark')
      showSuccessMessage('Региональный парк удален')
    } catch (err) {
      showErrorMessage('Не удалось удалить региональный парк')
      return Promise.reject(err)
    } finally {
      commit(TOGGLE_LOADING, false)
    }
  },
  async getPegionParkByID({ commit }, id) {
    try {
      const response = await Api.schedule.regionPark.getRegionParkById({
        regionParkId: id,
      })
      return response
    } catch (err) {
      showErrorMessage('Не удалось получить региональный парк')
      return Promise.reject(err)
    } finally {
      commit(TOGGLE_LOADING, false)
    }
  },
}

const getters = {
  getRegionParks(state) {
    return state.regionPark
  },
  getRegionalCarParkByID(state) {
    return (parkId) => {
      return state.regionPark.filter((e) => e.regionParkId === parkId)[0] || false
    }
  },
  getBaseInfo() {
    return state.regionPark.map((e) => {
      return {
        id: e.regionParkId,
        name: e.name,
      }
    })
  },
  getSettingsIdByParkId(state) {
    return (parkId) => {
      if (!parkId || parkId === 'all') return undefined
      const park = state.regionPark.filter((e) => e.regionParkId === parkId)[0]
      return park?.settingsId || park?.parentParkSettingsId || undefined
    }
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
